module.exports = __webpack_public_path__ + "static/img/3.2d4e42c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/3.png
// module id = GSnE
// module chunks = 0